import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import { AuthService } from 'libs/auth/src/lib/auth.service';
import { AuthUtils } from 'libs/auth/src/lib/auth-utils';
import { Router } from '@angular/router';
import { UtilsService } from './utils.service';
import { environment } from './app-settings.service';
import { ekranHataKaydi } from './ekran-hata-kaydi'; // DKM-5193 Cedric

import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { throwError } from 'rxjs';
import { UserActivityService } from '@dabnet-kamu/libs/auth';




@Injectable({ providedIn: 'root' })
export class DataCoreService {

  constructor(
    private utilsService: UtilsService,
    private authService: AuthService
  ) {}

  private appendAuth(ajaxOptions: any) {
    // dtokgoz 16.10: OData istekleri interceptor'dan geçmiyor → hatanın kaynağı için son istek buradan (hiç fırlatmaz)
    ekranHataKaydi.istek(ajaxOptions?.method || ajaxOptions?.type, ajaxOptions?.url);
    const user = this.authService.loggedUser;
    if (!user || this.authService.isAccessTokenExpired(user, 5)) {
      return;
    }

    ajaxOptions.headers = {
      ...(ajaxOptions.headers || {}),
      Authorization: `Bearer ${user.access_token}`,
    };
  }

  /**
   * DevExtreme (AspNetData / CustomStore) AJAX istekleri HttpInterceptor'ı bypass eder.
   * Bu helper ile ilgili ajaxOptions'a Authorization header'ını merkezi olarak ekleyebiliriz.
   */
  appendAuthHeader(ajaxOptions: any) {
    this.appendAuth(ajaxOptions);
  }


  getOData(
    entity: string,
    join: string[] | null = null,
    arrowFunction?: (e: any) => void,
    keyField: string = 'Kod',
    defaultValues?: any[],
    paginate = true,
    pageSize = 10,
    crudEntity?: string
  ) {
    // VWD-PERF 2026-10-07: grid (dk-dx-data-table2) DList PARAMS {"ilkSatirlar":true} ise bu ayarı yakar;
    // yalnız 'load' isteklerine ilkSatirlar=1 eklenir, DataServices sayfa sorgusuna FIRST_ROWS ipucu koyar.
    const dkAyar = { ilkSatirlar: false };
    const store = AspNetData.createStore({
      key: keyField === 'Id' ? keyField : 'Kod',
      loadUrl: environment.dataService + entity,
      insertUrl: environment.dataService + (crudEntity ?? entity),
      updateUrl: environment.dataService + (crudEntity ?? entity),
      deleteUrl: environment.dataService + (crudEntity ?? entity),

      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.contentType = 'application/json';
        this.appendAuth(ajaxOptions);
        if (method === 'load' && dkAyar.ilkSatirlar) {
          ajaxOptions.data = { ...(ajaxOptions.data || {}), ilkSatirlar: '1' };
        }

        // Eski AspNetData davranışını koru: values -> JSON ve /{id} ekleme
        try {
          if (method === 'update') {
            const recordId = ajaxOptions.data?.key;
            if (ajaxOptions.data?.values) {
              const rawValues = ajaxOptions.data.values;
              const jsonObject =
                typeof rawValues === 'string' ? JSON.parse(rawValues) : rawValues;
              ajaxOptions.data = JSON.stringify(jsonObject);
            }
            if (recordId !== undefined && recordId !== null) {
              ajaxOptions.url += `/${recordId}`;
            }
          } else if (method === 'delete') {
            const recordId = ajaxOptions.data?.key;
            if (recordId !== undefined && recordId !== null) {
              ajaxOptions.url += `/${recordId}`;
            }
            // Backend sadece route param ile id bekliyor, body istemiyor
            ajaxOptions.data = undefined;
          } else if (method === 'insert' && ajaxOptions.data?.values) {
            const rawValues = ajaxOptions.data.values;
            const jsonObject =
              typeof rawValues === 'string' ? JSON.parse(rawValues) : rawValues;
            ajaxOptions.data = JSON.stringify(jsonObject);
          }
        } catch (e) {
          console.warn('DataCoreService.getOData onBeforeSend parse error', e);
        }
      },

      onLoaded: arrowFunction,

      onInserting: e => {
        defaultValues?.forEach(([field, value]) => {
          if (e[field] == null) {
            e[field] = value;
          }
        });
      },

      onInserted: () => this.utilsService.showSuccess('Kayıt eklendi.'),
      onUpdated: () => this.utilsService.showSuccess('Kayıt güncellendi.'),

      // DKM-5193 Cedric: OData istekleri interceptor'dan geçmiyor → hata kaydına buradan yaz (e.error'a dokunmaz)
      onAjaxError: e => this.ajaxHatasiKaydet(e, environment.dataService + entity),

      errorHandler: err => {
        this.utilsService.showError(this.simplifyError(err));
      }
    });

    (store as any).__dkAyar = dkAyar;

    return new DataSource({
      store,
      paginate,
      pageSize,
      cacheRawData: false
    });
  }

  /**
   * DKM-5193 Cedric: AspNetData onAjaxError → ekran hata kaydı. Kütüphane bu çağrıdan sonra `error = e.error` okur;
   * burada `e`'ye yazılmaz, hiçbir şey döndürülmez ve istisna dışarı kaçmaz → ekranın aldığı hata/akış aynen kalır.
   */
  private ajaxHatasiKaydet(e: any, url: string): void {
    try {
      ekranHataKaydi.odata(e, url);
    } catch {
      // sessiz
    }
  }

  simplifyError(error: any): string {
    try {

     const parsedErrorMessage = typeof error?.message === 'string' ? JSON.parse(error.message) : '';


      var errorMessage:string;
      let listItems = '';

  
      if (parsedErrorMessage?.Error.Details?.length > 0) {
        // Detaylı hata mesajı mevcut
        listItems = '<ul>';
        parsedErrorMessage.Error.Details.forEach((item: any) => {
          listItems += `<li>${item.Message}</li>`;
        });
        listItems += '</ul>';
        errorMessage = listItems;
      } else {
        // Detaylı mesaj yoksa genel hata mesajını al
        errorMessage = parsedErrorMessage.Error.Message;
      }

      return errorMessage || 'Bir hata oluştu.'
    
    
    } catch {
      return 'Bir hata oluştu';
    }
  }

  getFormName(page: string): string {
    return page?.slice(page.lastIndexOf('/') + 1);
  }


  updateDataStore(
    entity: string,
    data: any,
    key: string = 'Kod',
    formName?: string
  ): Promise<any> {

    const store = AspNetData.createStore({
      key,
      updateUrl: environment.dataService + entity,

      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.contentType = 'application/json';
        this.appendAuth(ajaxOptions);

        // Eski yapıyla uyumlu: values -> JSON ve /{id}[?FormName=...] ekle
        if (method === 'update') {
          try {
            const recordId = ajaxOptions.data?.key;
            if (ajaxOptions.data?.values) {
              const rawValues = ajaxOptions.data.values;
              const jsonObject =
                typeof rawValues === 'string' ? JSON.parse(rawValues) : rawValues;
              ajaxOptions.data = JSON.stringify(jsonObject);
            }

            if (recordId !== undefined && recordId !== null) {
              ajaxOptions.url += formName
                ? `/${recordId}?FormName=${this.getFormName(formName)}`
                : `/${recordId}`;
            }
          } catch (e) {
            console.warn('DataCoreService.updateDataStore onBeforeSend parse error', e);
          }
        }
      },
      // DKM-5193 Cedric
      onAjaxError: e => this.ajaxHatasiKaydet(e, environment.dataService + entity)
    });

    return store.update(data[key], { ...data });
  }

  createDataStore(
    entity: string,
    data: any,
    key: string = 'Kod',
    formName?: string
  ): Promise<any> {

    const store = AspNetData.createStore({
      key,
      insertUrl: formName
        ? `${environment.dataService}${entity}?FormName=${this.getFormName(formName)}`
        : `${environment.dataService}${entity}`,

      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.contentType = 'application/json';
        this.appendAuth(ajaxOptions);

        // DevExtreme AspNetData, default olarak body'yi "values=..." şeklinde gönderir.
        // Backend tarafı saf JSON beklediği için, eski davranışı korumak adına
        // values içindeki JSON'u çıkarıp doğrudan body olarak gönderiyoruz.
        if (method === 'insert' && ajaxOptions.data && ajaxOptions.data.values) {
          try {
            const rawValues = ajaxOptions.data.values;
            const jsonObject =
              typeof rawValues === 'string' ? JSON.parse(rawValues) : rawValues;
            ajaxOptions.data = JSON.stringify(jsonObject);
          } catch (e) {
            console.warn('DataCoreService.createDataStore insert body parse error', e);
          }
        }
      },
      // DKM-5193 Cedric
      onAjaxError: e => this.ajaxHatasiKaydet(e, environment.dataService + entity)
    });

    return store.insert({ ...data });
  }

  removeDataStore(
    entity: string,
    data: any,
    key: string = 'Kod',
    formName?: string
  ): Promise<any> {

    const store = AspNetData.createStore({
      key,
      deleteUrl: environment.dataService + entity,

      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.contentType = 'application/json';
        this.appendAuth(ajaxOptions);

        // Eski yapıyla uyumlu: /{id}[?FormName=...] ekle
        if (method === 'delete') {
          try {
            const recordId = ajaxOptions.data?.key;
            if (recordId !== undefined && recordId !== null) {
              ajaxOptions.url += formName
                ? `/${recordId}?FormName=${this.getFormName(formName)}`
                : `/${recordId}`;
            }
            // Body gerekmediği için temizle
            ajaxOptions.data = undefined;
          } catch (e) {
            console.warn('DataCoreService.removeDataStore onBeforeSend parse error', e);
          }
        }
      },
      // DKM-5193 Cedric
      onAjaxError: e => this.ajaxHatasiKaydet(e, environment.dataService + entity)
    });

    return store.remove(data[key]);
  }



  formatDateForRapor(tarih: any) {
    return `${tarih.split('T')[0].split('-')[2]}-${
      tarih.split('T')[0].split('-')[1]
    }-${tarih.split('T')[0].split('-')[0]}`;
  }

  formatLocalDateForRapor(tarih: any) {
    const tarihObjesi = new Date(tarih);
    const gun = String(tarihObjesi.getDate()).padStart(2, '0'); // Günü al ve iki basamaklı yap
    const ay = String(tarihObjesi.getMonth() + 1).padStart(2, '0'); // Aylar 0 tabanlı olduğu için +1
    const yil = tarihObjesi.getFullYear(); // Yılı al

    let formatliTarih:string;
    tarih?formatliTarih = `${gun}-${ay}-${yil}`:null
    return formatliTarih;
  }

  formatDateWithSlash(date:string){
    console.log(date.split("/").reverse().join("-"))
    console.log(date.split("/").join("-"))
    let reFormattedDate:string = date.split("/").reverse().join("-");
    return reFormattedDate;
  }

  getNewDateLocalIsoDateTime(): string {
    const now = new Date();

    const pad = (n: number) => n.toString().padStart(2, '0');

    return (
      `${now.getFullYear()}-` +
      `${pad(now.getMonth() + 1)}-` +
      `${pad(now.getDate())}T` +
      `${pad(now.getHours())}:` +
      `${pad(now.getMinutes())}:` +
      `${pad(now.getSeconds())}`
    );
  }






}


// import { Injectable } from '@angular/core';
// import DataSource from 'devextreme/data/data_source';
// import * as AspNetData from 'devextreme-aspnet-data-nojquery';
// import { AuthService } from 'libs/auth/src/lib/auth.service';
// import { AuthUtils } from 'libs/auth/src/lib/auth-utils';
// import { Router } from '@angular/router';
// import { UtilsService } from './utils.service';
// import { environment } from './app-settings.service';
//
// import {HttpClient, HttpErrorResponse} from '@angular/common/http';
// import { throwError } from 'rxjs';
// import { UserActivityService } from '@dabnet-kamu/libs/auth';
//
// @Injectable({
//   providedIn: 'root',
// })
// export class DataCoreService {
//   public _authKey: string;
//
//   get authKey(): string | null {
//     // if (!this._authKey)
//     //   this._authKey = this.authService.loggedUser.access_token;
//
//     if (this._authKey && !AuthUtils.isTokenExpired(this._authKey)) {
//       return this.authService.loggedUser.access_token;;
//     } else {
//       //  this.authService.startLogout();
//
//       this.userActivityService.isUserActive().subscribe({
//         next: (isActive) => {
//           this.authService.getUserInfo().subscribe({
//             next: (token) => {
//               let expireDate = token.expires_at;
//               if (!isActive && Date.now() > expireDate * 1000) {
//                 this.authService.startLogout();
//                 return throwError(
//                   () => new Error('Session expired due to inactivity.')
//                 );
//               } else {
//                 return this._authKey;
//               }
//             },
//           });
//         },
//       });
//
//       return this._authKey;
//     }
//   }
//
//   private _entitySelectItems: any[] = [];
//
//   constructor(
//     public authService: AuthService,
//     public utilsService: UtilsService,
//     private router: Router,
//     private _httpClient: HttpClient,
//     private userActivityService: UserActivityService
//   ) {}
//
//   getOData(
//     entity: string,
//     join: string[] | null = null,
//     arrowFunction?: any,
//     keyField: string = 'Kod',
//     defaultValues?: any[],
//     paginate = true,
//     pageSize = 10,
//     crudEntity?: string
//   ) {
//     const store = AspNetData.createStore({
//       key: keyField === 'Id' ? keyField : 'Kod',
//       loadUrl: environment.dataService + entity,
//       insertUrl: environment.dataService + (crudEntity ? crudEntity : entity),
//       updateUrl: environment.dataService + (crudEntity ? crudEntity : entity),
//       deleteUrl: environment.dataService + (crudEntity ? crudEntity : entity),
//       loadParams:{
//       },
//       onBeforeSend: (method, ajaxOptions) => {
//         if(AuthUtils.isTokenExpired(this._authKey)){
//           this.authService.getAccessToken().subscribe(x=>this._authKey=x);
//         }
//
//         ajaxOptions.contentType = 'application/json';
//
//         ajaxOptions.headers = {
//           'Content-Type': 'application/json',
//           Authorization: 'Bearer ' + this.authKey,
//         };
//
//         if (method === 'update') {
//           const recordId = ajaxOptions.data.key;
//           const jsonObject = JSON.parse(ajaxOptions.data.values);
//           ajaxOptions.data = JSON.stringify(jsonObject);
//           ajaxOptions.url += `/${recordId}`;
//         } else if (method === 'delete') {
//           const recordId = ajaxOptions.data.key;
//           ajaxOptions.url += `/${recordId}`;
//         } else if (method === 'insert') {
//           const jsonObject = JSON.parse(ajaxOptions.data.values);
//           ajaxOptions.data = JSON.stringify(jsonObject);
//         }
//       },
//       onAjaxError: (e:any) => {
//         if(e.xhr.status === 401){
//           console.log("detect 401 error")
//           console.log("expire token?:",this._authKey)
//             this.authService.startLogout();
//         }
//
//
//         // Handle error (e.g., show notification)
//       },
//       onLoaded: (e: any) => {
//         if (arrowFunction) arrowFunction(e);
//       },
//       onInserting: (e: any) => {
//         if (defaultValues) {
//           // defaultValues içerisinde gelen alanları ve değerleri e'ye eklemek
//           defaultValues.forEach((defaultValue) => {
//             const [field, value] = defaultValue;
//             if (!e[field]) {
//               e[field] = value;
//             }
//           });
//         }
//       },
//       onInserted: (e: any) => {
//         this.utilsService.showSuccess('Kayıt eklendi.');
//       },
//       onUpdated: (e: any) => {
//         this.utilsService.showSuccess('Kayıt güncellendi.');
//       },
//       errorHandler: (err:any) => {
//         // Oturum süresi kontrolü
//         this.authService.getUserInfo().subscribe({
//           next: (token) => {
//             const now = Date.now();
//             const expiration = token.expires_at * 1000;
//             const twoMinutes = 2 * 60 * 1000;
//
//             if (now > expiration || (expiration - now) < twoMinutes) {
//               this.authService.startLogout();
//             }
//           },
//         });
//         this.utilsService.showError(err);
//         const simplified = this.simplifyError(err.message || err);
//         err.message= simplified;
//       }
//     });
//     return new DataSource({
//       store: store,
//       paginate: paginate,
//       pageSize: pageSize,
//       customQueryParams: environment.dataService + entity,
//       cacheRawData:false
//     });
//   }
//   simplifyError(error: any): string {
//     let parsedError: any;
//     let simplifiedMessage = 'Bir hata oluştu, lütfen tekrar deneyin.';
//     try {
//       if (error instanceof HttpErrorResponse) {
//         parsedError = typeof error.error === 'string' ? JSON.parse(error.error) : error.error;
//       } else if (typeof error === 'string') {
//         parsedError = JSON.parse(error);
//       } else if (error?.message && typeof error.message === 'string') {
//         parsedError = JSON.parse(error.message);
//       } else {
//         parsedError = error;
//       }
//
//       if (parsedError?.Error?.Details?.length > 0) {
//         simplifiedMessage = parsedError.Error.Details.map((d: any) => d.Message).join(' | ');
//       } else if (parsedError?.Error?.Message) {
//         simplifiedMessage = parsedError.Error.Message;
//       }
//     } catch {
//       // JSON parse hatası varsa varsayılan mesaj kalır
//     }
//
//     return simplifiedMessage;
//   }
//
//   updateDataStore(entity: string, data: any, key?: string, formName?: string) {
//     if (key === undefined) key = 'Kod';
//     const store = AspNetData.createStore({
//       key: key ? key : 'Kod',
//       updateUrl: environment.dataService + entity,
//       onBeforeSend: (method, ajaxOptions) => {
//         ajaxOptions.headers = {
//           'Content-Type': 'application/json',
//           Authorization: 'Bearer ' + this.authKey,
//         };
//
//         if (method === 'update') {
//           const recordId = ajaxOptions.data.key;
//           const jsonObject = JSON.parse(ajaxOptions.data.values);
//           ajaxOptions.data = JSON.stringify(jsonObject);
//           ajaxOptions.url += formName
//             ? `/${recordId}` + '?FormName=' + this.getFormName(formName)
//             : `/${recordId}`;
//         }
//       },
//     });
//     return store.update(data[key], { ...data });
//   }
//
//   createDataStore(entity: string, data: any, key?: string, formName?: string) {
//     if (key === undefined) key = 'Kod';
//     const store = AspNetData.createStore({
//       key: key ? key : 'Kod',
//       insertUrl: formName
//         ? environment.dataService +
//           entity +
//           '?FormName=' +
//           this.getFormName(formName)
//         : environment.dataService + entity,
//       onBeforeSend: (method, ajaxOptions) => {
//         ajaxOptions.headers = {
//           'Content-Type': 'application/json',
//           Authorization: 'Bearer ' + this.authKey,
//         };
//         if (method === 'insert') {
//           const jsonObject = JSON.parse(ajaxOptions.data.values);
//           ajaxOptions.data = JSON.stringify(jsonObject);
//         }
//       },
//       errorHandler: (err) => {
//
//       },
//     });
//
//     return store.insert({ ...data });
//   }
//
//   removeDataStore(entity: string, data: any, key?: string, formName?: string) {
//     if (key === undefined) key = 'Kod';
//     const store = AspNetData.createStore({
//       key: key ? key : 'Kod',
//       deleteUrl: environment.dataService + entity,
//       onBeforeSend: (method, ajaxOptions) => {
//         ajaxOptions.headers = {
//           'Content-Type': 'application/json',
//           Authorization: 'Bearer ' + this.authKey,
//         };
//
//         if (method === 'delete') {
//           const recordId = ajaxOptions.data.key;
//           ajaxOptions.url += formName
//             ? `/${recordId}` + '?FormName=' + this.getFormName(formName)
//             : `/${recordId}`;
//         }
//       },
//     });
//
//     return store.remove(data[key]);
//   }
//
//
//
//   getFormName(page: any): string {
//     return page?.slice(page?.lastIndexOf('/') + 1);
//   }
//
//   formatDateForRapor(tarih: any) {
//     return `${tarih.split('T')[0].split('-')[2]}-${
//       tarih.split('T')[0].split('-')[1]
//     }-${tarih.split('T')[0].split('-')[0]}`;
//   }
//
//   formatLocalDateForRapor(tarih: any) {
//     const tarihObjesi = new Date(tarih);
//     const gun = String(tarihObjesi.getDate()).padStart(2, '0'); // Günü al ve iki basamaklı yap
//     const ay = String(tarihObjesi.getMonth() + 1).padStart(2, '0'); // Aylar 0 tabanlı olduğu için +1
//     const yil = tarihObjesi.getFullYear(); // Yılı al
//
//     let formatliTarih:string;
//     tarih?formatliTarih = `${gun}-${ay}-${yil}`:null
//     return formatliTarih;
//   }
//
//   formatDateWithSlash(date:string){
//     console.log(date.split("/").reverse().join("-"))
//     console.log(date.split("/").join("-"))
//     let reFormattedDate:string = date.split("/").reverse().join("-");
//     return reFormattedDate;
//   }
//
//   getNewDateLocalIsoDateTime(): string {
//     const now = new Date();
//
//     const pad = (n: number) => n.toString().padStart(2, '0');
//
//     return (
//       `${now.getFullYear()}-` +
//       `${pad(now.getMonth() + 1)}-` +
//       `${pad(now.getDate())}T` +
//       `${pad(now.getHours())}:` +
//       `${pad(now.getMinutes())}:` +
//       `${pad(now.getSeconds())}`
//     );
//   }
//
//
//   /***********************************\
//   |********** ODATA ESKİ YAPI **********|
//    \***********************************/
//
//   // getOData(
//   //   entity: string,
//   //   join: string[] | null = null,
//   //   arrowFunction?: any,
//   //   key?: string,
//   //   defaultValues?: any[],
//   //   paginate = true,
//   //   pageSize = 10
//   // ) {
//   //   if (!join) join = [];
//
//   //   const store = new ODataStore({
//   //     url: `${environment.baseUrl}odata/${entity}`,
//   //     key: key === 'Id' ? key : 'Kod',
//   //     version: 4,
//   //     beforeSend: (e: any) => {
//   //       e.headers = {
//   //         'Content-Type': 'application/json',
//   //         Authorization: 'Bearer ' + this.authKey,
//   //       };
//   //     },
//   //     onLoaded: (e: any) => {
//   //       if (arrowFunction) arrowFunction(e);
//   //     },
//   //     onInserting: (e: any) => {
//   //       if (defaultValues) {
//   //         // defaultValues içerisinde gelen alanları ve değerleri e'ye eklemek
//   //         defaultValues.forEach((defaultValue) => {
//   //           const [field, value] = defaultValue;
//   //           if (!e[field]) {
//   //             e[field] = value;
//   //           }
//   //         });
//   //       }
//   //     },
//   //     errorHandler: (err) => {
//   //       this.utilsService.showError(err);
//   //     },
//   //   });
//   //   return new DataSource({
//   //     store: store,
//   //     expand: join,
//   //     paginate: paginate,
//   //     pageSize: pageSize,
//   //     // sort: key ? [{
//   //     //   selector: key,
//   //     //   desc: true
//   //     // }] : undefined,
//   //   });
//   // }
//
//   // createDataStore(entity: string, data: any, key?: string, formName?: string) {
//   //   const store = new DataSource({
//   //     store: {
//   //       type: 'odata',
//   //       url: formName
//   //         ? `${environment.baseUrl}odata/${entity}?FormName=${this.getFormName(
//   //             formName
//   //           )}`
//   //         : `${environment.baseUrl}odata/${entity}`,
//   //       key: key === 'Id' ? key : 'Kod',
//
//   //       // errorHandler:(err) => {
//   //       //   this.utilsService.showError('İşlem gerçekleştirilemedi!')
//   //       // },
//   //       version: 4,
//   //       beforeSend: (e: any) => {
//   //         e.method = 'POST';
//   //         e.headers = {
//   //           'Content-Type': 'application/json',
//   //           Authorization: 'Bearer ' + this.authKey,
//   //         };
//   //       },
//   //     },
//   //   });
//   //   const x = store.store();
//   //   return x.insert({ ...data });
//   // }
//
//   // updateDataStore(entity: string, data: any, key?: string, formName?: string) {
//   //   let updatedKey = key === 'Id' ? key : 'Kod';
//   //   const store = new DataSource({
//   //     /*  store: {
//   //       type: 'odata',
//   //       url: updatedKey === 'Id' ? (formName?`${environment.baseUrl}odata/${entity}/${data.Id}?FormName=${this.getFormName(formName)}`:`${environment.baseUrl}odata/${entity}/${data.Id}`) : (formName?`${environment.baseUrl}odata/${entity}(${data.Kod})?FormName=${this.getFormName(formName)}`:`${environment.baseUrl}odata/${entity}`),
//   //       key: updatedKey,
//   //       version: 4,
//   //       beforeSend: (e: any) => {
//   //         e.method = 'PUT';
//   //         e.headers = { "Content-Type": "application/json", "Authorization": 'Bearer ' +  this.authKey};
//   //       },
//   //     }, */
//   //   });
//
//   //   const x = store.store();
//   //   return x.update(data.Kod, { ...data });
//   // }
//
//   // removeDataStore(entity: string, data: any, key?: string, formName?: string) {
//   //   let updatedKey = key === 'Id' ? key : 'Kod';
//   //   const store = new DataSource({
//   //     store: {
//   //       type: 'odata',
//   //       url:
//   //         updatedKey === 'Id'
//   //           ? formName
//   //             ? `${environment.baseUrl}odata/${entity}/${
//   //                 data.Id
//   //               }?FormName=${this.getFormName(formName)}`
//   //             : `${environment.baseUrl}odata/${entity}/${data.Id}`
//   //           : formName
//   //           ? `${environment.baseUrl}odata/${entity}(${
//   //               data.Kod
//   //             })?FormName=${this.getFormName(formName)}`
//   //           : `${environment.baseUrl}odata/${entity}`,
//   //       key: updatedKey,
//   //       version: 4,
//   //       beforeSend: (e: any) => {
//   //         e.method = 'DELETE';
//   //         e.headers = {
//   //           'Content-Type': 'application/json',
//   //           Authorization: 'Bearer ' + this.authKey,
//   //         };
//   //       },
//   //     },
//   //   });
//   //   const x = store.store();
//   //   return x.remove(data.Kod);
//   // }
// }
